// crypto.randomUUID throws on insecure origins (http://); fall back to a
// timestamped suffix that's unique enough for client-side widget IDs.
export const generateWidgetId = (): string => {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID()
    }
  } catch {
    /* fall through */
  }
  return `w-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}
